import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Box,
  ModalFooter,
  Text,
  Flex
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { FaTruck } from 'react-icons/fa'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationConfigTolerancia from '@hook/parametrization/use-config-tolerancia'
import useFilters from '@hook/shared/use-filters'

import Filter from '@component/Shared/Filter'

// Tipagem
interface IValue {
  label: string
  value: string
}

const ModalCreateTolerancia: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [usuario, setUsuario] = useState<IValue>(null)
  const { data } = useFilters()
  const [tolerancia, setTolerancia] = useState('')
  const { createTolerancia, companieId } = useParametrizationConfigTolerancia()

  const [errors, setErrors] = useState<string[]>([])

  const validate = () => {
    const newErrors: string[] = []
    if (usuario === null) {
      newErrors.push('Selecione um usuário.')
    }
    if (!tolerancia || tolerancia.trim() === '') {
      newErrors.push('Tolerância é obrigatória.')
    } else if (isNaN(Number(tolerancia)) || Number(tolerancia) < 0) {
      newErrors.push('Tolerância deve ser um número maior ou igual a 0.')
    }
    setErrors(newErrors)
    return newErrors.length === 0
  }

  const clearForm = () => {
    setUsuario(null)
    setTolerancia('')
    setErrors([])
  }

  // Validar se todos os campos obrigatórios estão preenchidos
  const isFormValid = () => {
    return (
      usuario !== null && // Perfil selecionado
      tolerancia && // Tolerância preenchida
      tolerancia.trim() !== '' && // Tolerância não é apenas espaços
      !isNaN(Number(tolerancia)) && // Tolerância é um número válido
      Number(tolerancia) >= 0 // Tolerância é um número positivo ou zero
    )
  }

  const [isSaving, setIsSaving] = useState(false)

  const handleSubmit = async () => {
    if (isSaving) return
    if (validate()) {
      setIsSaving(true)
      const success = await createTolerancia({
        empresaId: companieId,
        tolerancia: Number(tolerancia),
        perfilId: Number(usuario.value)
      })
      setIsSaving(false)
      // Fecha só no sucesso; no erro o toast explica e o formulário continua preenchido
      if (success !== false) {
        onClose()
        clearForm()
      }
    }
  }
  return (
    <>
      <Button
        fontSize={14}
        size="sm"
        leftIcon={<IoIosAddCircle />}
        colorScheme="blue"
        variant="outline"
        onClick={onOpen}
      >
        Adicionar
      </Button>

      <Modal
        isCentered
        isOpen={isOpen}
        onClose={() => {
          onClose()
          clearForm()
        }}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        size="md"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <FaTruck />
              </Box>
              <Box p={2} pt={1}>
                Criar Tolerancia Cronograma
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired mb={4}>
              <Filter
                {...({
                  label: 'Perfil',
                  options: data.profiles,
                  isMulti: false,
                  value: usuario ? [usuario] : [],
                  onChange: (value: IValue) => setUsuario(value as IValue),
                  menuPortalTarget: document.body,
                  styles: {
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }
                } as any)}
              />
            </FormControl>

            <FormControl isRequired mb={4}>
              <FormLabel>Tolerância</FormLabel>
              <Input
                type="number"
                min={0}
                borderColor="gray.400"
                value={tolerancia}
                onChange={e => setTolerancia(e.target.value)}
              />
            </FormControl>

            {/* Mensagens de Erro */}
            {errors.length > 0 && (
              <Box mt={2}>
                {errors.map((err, idx) => (
                  <Text key={idx} color="red.500" fontSize="sm">
                    {err}
                  </Text>
                ))}
              </Box>
            )}
          </ModalBody>

          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                onClose()
                clearForm()
              }}
            >
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={handleSubmit}
              isLoading={isSaving}
              _hover={{ bg: 'green.500' }}
              _active={{ bg: 'green.500' }}
              isDisabled={!isFormValid()}
              _disabled={{ bg: 'gray.300', color: 'gray.500' }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ModalCreateTolerancia
